import {
  CONFIRMED_GET_PATIENT_MALE_CHARTS,
  CONFIRMED_CREATE_PATIENT_MALE_CHART,
  CONFIRMED_DELETE_PATIENT_MALE_CHART,
  CONFIRMED_EDIT_PATIENT_MALE_CHART,
} from "../actions/PatientMalechartType"

const initialState = {
  patientMaleCharts: [],
  loading: false,
  error: null,
}

export default function PatientMaleChartReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_PATIENT_MALE_CHARTS: {
      return {
        ...state,
        loading: false,
        patientMaleCharts: action.payload,
        error: null,
      }
    }

    case CONFIRMED_CREATE_PATIENT_MALE_CHART: {
      const newChart = action.payload.data || action.payload
      return {
        ...state,
        loading: false,
        patientMaleCharts: [...state.patientMaleCharts, newChart],
        error: null,
      }
    }

    case CONFIRMED_EDIT_PATIENT_MALE_CHART: {
      const updatedChart = action.payload.data || action.payload
      return {
        ...state,
        loading: false,
        patientMaleCharts: state.patientMaleCharts.map((item) =>
          item.chart_id === updatedChart.chart_id ? updatedChart : item,
        ),
        error: null,
      }
    }

    case CONFIRMED_DELETE_PATIENT_MALE_CHART: {
      const chartId = action.payload.chart_id
      return {
        ...state,
        loading: false,
        patientMaleCharts: state.patientMaleCharts.filter((item) => item.chart_id !== chartId),
        error: null,
      }
    }

    default:
      return state
  }
}
